const ELIGIBLE_SEARCH_TYPES = ['CITY', 'STATE', 'ZIPCODE', 'NEIGHBORHOOD'];

function sanitizePrice(value) {
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === 'string') {
        const parsedValue = Number(value.replace(/[$,]/g, ''));
        return Number.isFinite(parsedValue) ? parsedValue : null;
    }
    return null;
}

export function getCurrentPagePriceRange(currentPageListings) {
    if (!Array.isArray(currentPageListings) || currentPageListings.length === 0) {
        return null;
    }

    const listingPrices = currentPageListings
        .map((listing) => sanitizePrice(listing?.price))
        .filter((price) => typeof price === 'number' && price > 0);

    if (listingPrices.length === 0) {
        return null;
    }

    const lowPrice = Math.min(...listingPrices);
    const highPrice = Math.max(...listingPrices);

    if (lowPrice <= 0 || highPrice <= 0 || lowPrice > highPrice) {
        return null;
    }

    return { lowPrice, highPrice };
}

export function getAggregateOfferProductName(geo, searchType) {
    if (!geo) {
        return null;
    }
    switch (searchType) {
        case 'CITY':
            return geo.city && geo.state ? `${geo.city}, ${geo.state} Real Estate` : null;
        case 'STATE':
            return `${geo.stateFullName || geo.state} Real Estate`;
        case 'ZIPCODE':
            return geo.zipcode && geo.state ? `${geo.zipcode}, ${geo.state} Real Estate` : null;
        case 'NEIGHBORHOOD':
            return geo.neighborhood && geo.city && geo.state
                ? `${geo.neighborhood}, ${geo.city}, ${geo.state} Real Estate`
                : null;
        default:
            return null;
    }
}

export function shouldRenderAggregateOfferSchema({ searchType, vanillaCase, rentals, isSold, currentPageListings }) {
    if (!vanillaCase || rentals || isSold) {
        return false;
    }
    if (!ELIGIBLE_SEARCH_TYPES.includes(searchType)) {
        return false;
    }
    return !!getCurrentPagePriceRange(currentPageListings);
}

export function buildAggregateOfferSchema({ geo, searchType, currentPageListings, vanillaCase, rentals, isSold }) {
    if (!shouldRenderAggregateOfferSchema({ searchType, vanillaCase, rentals, isSold, currentPageListings })) {
        return null;
    }

    const priceRange = getCurrentPagePriceRange(currentPageListings);
    const name = getAggregateOfferProductName(geo, searchType);
    if (!priceRange || !name) {
        return null;
    }

    return {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name,
        offers: {
            '@type': 'AggregateOffer',
            highPrice: priceRange.highPrice,
            lowPrice: priceRange.lowPrice,
            priceCurrency: 'USD',
        },
    };
}

export function buildAggregateOfferSchemaScriptTag(options) {
    const schema = buildAggregateOfferSchema(options);
    if (!schema) {
        return null;
    }
    return `<script type="application/ld+json">${JSON.stringify(schema)}</script>`;
}
